<template>
	
<com-section :section="section" :title="section.effects.title" :instruction="section.effects.instruction" :completed="completed" :active="active" v-on:next="$emit('next')" v-on:back="$emit('back')">

	<div class="text" v-html="section.effects.text"></div>

	<template v-if="spot === 'spine'">
		<img src="@/assets/aid/health/spine.gif" width="200"  class="effects-image" />
		<div class="inside-image-expand" v-on:click="$emit('video')">expand</div>
	</template>

	<img src="@/assets/aid/health/hip.svg" width="200" v-if="spot === 'hip'" class="effects-image" />

</com-section>

</template>

<script>

import comSection from './Section'

export default {

	props: ['section', 'active', 'completed', 'spot'],

	components: {
		'com-section': comSection
	}
	
}

</script>

<style scoped>

.effects-image {
	min-height: 200;
	margin: 0px auto;
	margin-top: 16px;
	display: block;
}

.is-patient .inside-image-expand {
	background-image: url(~@/assets/icon.expand.patient.svg);
}

.inside-image-expand{
	background-image: url(~@/assets/icon.expand.svg);
	padding-left: 24px;
	line-height: 16px;
	color: #343434;
	letter-spacing: 1px;
	cursor: pointer;
	background-repeat: no-repeat;
	display: inline-block;
	margin: 0px auto;
	text-transform: uppercase;
	font-weight: 600;
	margin-top: 16px;
	font-size: 12px;
}

</style>